import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import AddSong from './AddSong';
import AddIcon from '@mui/icons-material/Add';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleSongList } from '../../../../_services/creater/creatorSongList.service';
import { useDispatch, useSelector } from 'react-redux';
import { updateSongSequence } from '../../../../_services/creater/creatorSongSequence';
import SnackbarContainer from '../../../Snackbar';
import {
  setSnackBar,
  setSnackBarMessage,
  setSnackBarVariant,
} from '../../../../redux';
import { formSnackbar } from '../../../../_services/_constants/snackbar.constant';
import { handleTagList } from '../../../../_services/tags/tagList.service';
import { handleRelatedPlatform } from '../../../../_services/creater/relatedPlatfom.service';
import { getStreamingPlatforms } from '../../../../_services/creater/streamingPlatform.service';
import { getGenre, getLanguage } from '../../../../_services/profile';
import { moodRequest } from '../../../../_services/profile/mood.service';
import { SkeletonWaveCard } from '../../../../_helpers/reusablefunctions/SkeletonCard';
import { getAllPlaylistOfUser } from '../../../../_services/playlist/getAllPlaylistOfUser';

function SongListComp() {
  const userData = useSelector((state) => state.userData.userData);
  const dispatch = useDispatch();

  const [songsList, setSongsList] = useState([]);
  const [songListBKP, setSongListBKP] = useState([]);
  const [disableStatus, setDisableStatus] = useState(false);
  const [songTagsList, setSongTagsList] = useState([]);
  const [allPlatfromList, setAllPlatformList] = useState([]);
  const [allPlatfromListCopy, setAllPlatformListCopy] = useState([]);
  const [genre, setGenre] = useState([]);
  const [moodList, setMoodList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [relatedPlatform, setRelatedPlatform] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingStart, setLoadingStart] = useState(true);
  const [playlistItems, setPlaylistItems] = useState([]);
  const [playlistLoading, setPlaylistLoading] = useState(false);

  const breadcrumbs = [
    { label: 'Song Hub', link: '/songhub' },
    { label: 'Music', link: '/songhub' },
  ];

  const showError = (msg = formSnackbar.errors.errorMsg) => {
    dispatch(setSnackBar(true));
    dispatch(setSnackBarMessage(msg));
    dispatch(setSnackBarVariant('error'));
    setTimeout(() => dispatch(setSnackBar(false)), 2000);
  };

  const getSongList = async () => {
    try {
      setLoadingStart(true);
      const dataObj = { userId: userData.id };
      const response = await handleSongList(dataObj, 'GETBYUSER');
      if (response.status === 200 || response.status === 204 || response.status === 201) {
        const results = response.data.results || [];
        setSongListBKP(results);
        if (results.length > 0) {
          const data = [...results].sort((a, b) => parseInt(a.song_order) - parseInt(b.song_order));
          setSongsList(data);
          setDisableStatus(false);
        } else {
          setDisableStatus(true);
          setSongsList([{}, ...songsList]);
        }
      } else {
        showError();
      }
    } catch {
      showError();
    }
    finally {
      setLoadingStart(false);
    }
  };

  useEffect(() => {
    if (userData.id) getSongList();
  }, [userData.id]);

  const addNewSongHandler = () => {
    setSongsList([{}, ...songsList]);
    setDisableStatus(true);
  };

  const deleteSongHandler = async (id) => {
    const items = songsList;
    setSongsList(items.filter((item) => item.id !== id));
    setDisableStatus(false);
    if (id !== undefined) {
      dispatch(setSnackBar(true));
      dispatch(setSnackBarMessage(formSnackbar.songPlaylist.songLinkDelete));
      dispatch(setSnackBarVariant('info'));
      if (JSON.stringify(items[0]) === '{}') setDisableStatus(true);
      try {
        const dataObj = { userId: userData.id, songId: id };
        const response = await handleSongList(dataObj, 'DELETE');
        if (response.status === 200 || response.status === 204) {
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
          dispatch(setSnackBarMessage(formSnackbar.songPlaylist.songLinkDeleteSuccess));
          dispatch(setSnackBarVariant('success'));
        } else {
          showError();
        }
      } catch {
        showError();
      }
    }
  };

  const handleOnDragEnd = async (result) => {
    if (!result.destination) return;
    const items = Array.from(songsList);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setSongsList(items);
    const data = items.map(song => song.id);
    try {
      const dataObj = { song_ids: data.join(',') };
      const response = await updateSongSequence(userData.id, dataObj);
      if (response.status === 200) {
        getSongList();
      } else {
        showError();
      }
    } catch {
      showError();
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const tagRes = await handleTagList({}, 'GET');
        setSongTagsList(tagRes.status === 200 ? tagRes.data.data : []);
      } catch {
        showError();
      }
      getPlatformList();
    };
    fetchInitialData();
    // eslint-disable-next-line
  }, []);

  const getRelatedPlatforms = async (id) => {
    console.debug('getRelatedPlatforms', { id });
    if (id) {
      try {
        setLoading(true);
        const dataObj = { songId: id, userId: userData.id };
        const response = await handleRelatedPlatform(dataObj, 'GETBYSONG');
        if (response.status === 200) {
          const arrayData = response.data.data || [];
          const data = arrayData.sort((a, b) => parseInt(a.platform_order) - parseInt(b.platform_order));
          setRelatedPlatform(data);
        } else {
          showError();
        }
      } catch {
        showError();
      }
      finally {
        setLoading(false);
      }
    }
  };

  const reRenderPlatformHandler = (id) => getRelatedPlatforms(id);

  const getPlatformList = async () => {
    try {
      const platformRes = await getStreamingPlatforms();
      if (platformRes.status === 200) {
        setAllPlatformList(platformRes.data.data);
        setAllPlatformListCopy(platformRes.data.data);
      } else {
        showError();
      }
    } catch {
      showError();
    }
    try {
      const genreRes = await getGenre();
      setGenre(genreRes.data.data);
    } catch { }
    try {
      const langRes = await getLanguage();
      setLanguageList(langRes.data ? langRes.data.data : []);
    } catch { }
    try {
      const moodRes = await moodRequest();
      setMoodList(moodRes.data.data);
    } catch { }
  };

  // -------createplaylist function
  const getPlaylistList = useCallback(() => {
    setPlaylistLoading(true);
    getAllPlaylistOfUser({ search: userData.id, limit: 5, offset: 0 })
      .then((response) => {
        setPlaylistItems(response.data.results);
        setPlaylistLoading(false);
      })
      .catch((error) => {
        setPlaylistLoading(false);
        // handle error if needed
      });
  }, [userData.id]);

  const renderCard = useCallback(
    (card, index, provided) => (
      <AddSong
        key={card.id || index}
        deleteSongHandler={deleteSongHandler}
        index={index}
        id={card.id}
        data={card}
        songTitle={card.songTitle}
        provided={provided}
        disableHandler={() => setDisableStatus(false)}
        renderSongList={getSongList}
        songsListData={songsList}
        songTagsList={songTagsList}
        allPlatfromList={allPlatfromList}
        allPlatfromListCopy={allPlatfromListCopy}
        setAllPlatformList={setAllPlatformList}
        relatedPlatform={relatedPlatform}
        setRelatedPlatform={setRelatedPlatform}
        genre={genre}
        moodList={moodList}
        languageList={languageList}
        reRenderPlatformHandler={reRenderPlatformHandler}
        getRelatedPlatforms={getRelatedPlatforms}
        loading={loading}
        // playlist state and functions
        setPlaylistLoading={setPlaylistLoading}
        playlistLoading={playlistLoading}
        setPlaylistItems={setPlaylistItems}
        playlistItems={playlistItems}
        getPlaylistList={getPlaylistList}
      />
    ),
    [
      songsList,
      songTagsList,
      allPlatfromList,
      allPlatfromListCopy,
      genre,
      moodList,
      languageList,
      relatedPlatform,
      loading,
      playlistLoading
    ]
  );

  return (
    <div className="container-fluid py-4 creator-playlist-panel">
      <div className="row m-0">
        <div className="col-12">
          <div>
            <h2>Song Hub</h2>
            <div className="d-flex">
              {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={breadcrumb.label}>
                  {index > 0 && (
                    <div style={{ width: '20px', marginLeft: '10px' }} className="text-secondary">
                      ◆
                    </div>
                  )}
                  <div>
                    <Link
                      to={breadcrumb.link}
                      style={{ textDecoration: 'none', color: 'gray', fontSize: '0.8rem' }}
                    >
                      {breadcrumb.label}
                    </Link>
                  </div>
                </React.Fragment>
              ))}
            </div>
            <div className="pt-4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${process.env.REACT_APP_CREATORURL}${userData?.userHandle}/music`}
              >
                {`${process.env.REACT_APP_CREATORURL}${userData?.userHandle}/music`}
              </a>
            </div>
          </div>
          <div className="my-4">
            <button
              disabled={disableStatus}
              className="gn-actionbtn"
              onClick={addNewSongHandler}
            >
              <AddIcon />
              ADD NEW
            </button>
          </div>
          {
            loadingStart ? (
              <div>
                {[1, 2, 3].map((i) => (
                  <SkeletonWaveCard key={i} />
                ))}
              </div>
            ) : (
              <div className="row pb-5">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="characters">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="characters creator-songs-list col-sm-12 col-md-12 col-lg-8 col-xl-6"
                      >
                        {songsList.length > 0 &&
                          songsList.map((item, index) => (
                            <Draggable
                              key={item.id || index}
                              draggableId={String(item.id || index)}
                              index={index}
                            >
                              {(provided) => renderCard(item, index, provided)}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            )
          }

        </div>
      </div>
      <SnackbarContainer />
    </div>
  );
}

export default SongListComp;
